import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import MaterialTable from "material-table";
import { ToastContainer, toast } from "react-toastify";
import ContentLoader from "react-content-loader";
import axios from "axios";

import authHeader from "../../services/auth-header";
import { API } from "../../backend";
import DeleteCompanyUserService from "../../services/user/deleteUserService";
import ActivateUserService from "../../services/user/activateUserService";
import Helper from "../../Helper";
import { getTrans as t } from "../../Localization/translations";
import ActivateDeActivatedCustomerUserService from "../../services/user/customeruseractiveService";

function ManageUser() {
  const customertable = useRef();
  const [items, setItems] = useState([]);
  const [customerusers, setCustomerUser] = useState([]);
  const customerPermission = localStorage.getItem("customer");

  const [successful, setSuccessful] = useState(false);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const handelDefault = () => {
    let url = API + "company/users/";
    axios.get(url, { headers: authHeader() }).then((response) => {
      setItems(response.data);
      setLoading(false);
    })
  
  };

  const handelDefaultcustomer = () => {
    let url = API + "company/customerusers/";
    axios.get(url, { headers: authHeader() }).then((response) => {
      setCustomerUser(response.data);
    })
    
  };

  const handlecustomer = () => {
    let url = API + "company/customeruserslist/";
    axios.get(url, { headers: authHeader() }).then((response) => {
      setCustomerUser(response.data);
      setLoading(false);
    })
   
  };
  const handleBan = (id, user_id, status) => {
    DeleteCompanyUserService.deleteUser(id, user_id, status).then(
      (response) => {
        if (response.data.success) {
          setSuccessful(true);
          setCount(count + 1);
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSuccessful(false);
        }
      }
    )
    
  };

  const handleActivation = (id) => {
    ActivateUserService.activateUser(id).then((response) => {
      if (response.data.success) {
        toast.success(`${response.data.response}`, {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setSuccessful(true);
      } else {
        toast.error(`${response.data.error}`, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setSuccessful(false);
      }
    })
   
  };

  const handleCustomerActivation = (id) => {
    ActivateDeActivatedCustomerUserService.ActiveDeactiveUser(id).then(
      (response) => {
        if (response.data.success) {
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setTimeout(() => {
            handelDefaultcustomer();
          }, 1000);
          setSuccessful(true);
        } else {
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });

          setSuccessful(false);
        }
      }
    )
  
  };

  let navigate = useNavigate();
  const handleEdit = (id) => {
    navigate("/user/edituser", { state: id });
  };

  const handleCustomerEdit = (id) => {
    navigate("/user/editcustomeruser", { state: id });
  };

  useEffect(() => {
    if (customerPermission !== "Customer") {
      handelDefault();
      handelDefaultcustomer();
    } else {
      handlecustomer();
    }
  }, [count]);
  return (
    <>
      <div className="">
        <ToastContainer />
        <div className="content container-fluid">
          {loading === false ? (
            <div className="row ">
              <div className="col-md-12">
                <div className="mb-0">
                  {customerPermission !== "Customer" ? (
                    <>
                      <div className="header pb-0 pt-3">
                        <div className="d-lg-flex">
                          <div>
                            <h5 className="mb-0 tc">
                              {t("Manage Company Users")}
                            </h5>
                          </div>
                          <div className="ms-auto my-auto mt-lg-0 mt-4">
                            <div className="ms-auto my-auto">
                              <Link to="/user/adduser">
                                {" "}
                                <button
                                  className="add mb-2 btn btn-primary mb-0"
                                  data-bs-toggle="modal"
                                  data-bs-target="#add_contact"
                                >
                                  +&nbsp; {t("New User")}
                                </button>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="body">
                        <div className="success">{/* {{msg}} */}</div>
                        <div className="p-0">
                          <MaterialTable
                            style={{
                              backgroundColor: "var(--bs-table-bg)",
                              borderBottomWidth: "1px",
                              boxShadow:
                                "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                            }}
                            columns={[
                              {
                                title: `${t("Full Name")}`,
                                field: "name",
                                headerStyle: {
                                  verticalAlign: "inherit",
                                  fontWeight: "bold",
                                  textAlign: "left",
                                },
                                cellStyle: {
                                  textAlign: "left",
                                  fontSize: 13,
                                },
                                render: (rowData) => (
                                  <>
                                    <div className="d-xl-none tc d-md-none d-lg-none">
                                      {t("Full Name")}
                                    </div>
                                    <div>{rowData.name}</div>
                                  </>
                                ),
                              },
                              {
                                title: `${t("Company Name")}`,
                                field: "company_name",
                                render: (rowData) => (
                                  <>
                                    <div className="d-xl-none tc d-md-none d-lg-none">
                                      {t("Company Name")}
                                    </div>
                                    <div>{rowData.company_name}</div>
                                  </>
                                ),
                                headerStyle: {
                                  verticalAlign: "inherit",
                                  fontWeight: "bold",
                                  textAlign: "left",
                                },
                                cellStyle: {
                                  textAlign: "left",
                                  fontSize: 12,
                                },
                              },
                              {
                                title: `${t("Email")}`,
                                field: "user_email",
                                render: (rowData) => (
                                  <>
                                    <div className="d-xl-none tc d-md-none d-lg-none">
                                      {t("Email")}
                                    </div>
                                    <div>{rowData.user_email}</div>
                                  </>
                                ),
                                headerStyle: {
                                  verticalAlign: "inherit",
                                  fontWeight: "bold",
                                  textAlign: "left",
                                },
                                cellStyle: {
                                  textAlign: "left",
                                  fontSize: 12,
                                },
                              },
                              {
                                title: `${t("Work Phone")}`,
                                field: "work_phone",
                                render: (rowData) => (
                                  <>
                                    <div className="d-xl-none tc d-md-none d-lg-none">
                                      {t("Work Phone")}
                                    </div>
                                    <div>
                                      {rowData.work_phone
                                        ? rowData.work_phone
                                        : "None"}
                                    </div>
                                  </>
                                ),
                                headerStyle: {
                                  verticalAlign: "inherit",
                                  fontWeight: "bold",
                                  textAlign: "left",
                                },
                                cellStyle: {
                                  textAlign: "left",
                                  fontSize: 12,
                                },
                              },
                              {
                                title: `${t("Start Date")}`,
                                field: "date_registered",
                                render: (rowData) => (
                                  <>
                                    <div className="d-xl-none tc d-md-none d-lg-none">
                                      {t("Start Date")}
                                    </div>
                                    <div>
                                      {Helper.DateNormal(
                                        rowData.date_registered
                                      )}
                                    </div>
                                  </>
                                ),
                                headerStyle: {
                                  verticalAlign: "inherit",
                                  fontWeight: "bold",
                                  textAlign: "left",
                                },
                                cellStyle: {
                                  textAlign: "left",
                                  fontSize: 12,
                                },
                              },
                              {
                                title: `${t("End Date")}`,
                                field: "date_deactivate",
                                render: (rowData) => (
                                  <>
                                    <div className="d-xl-none tc d-md-none d-lg-none">
                                      {t("End Date")}
                                    </div>
                                    <div>
                                      {rowData.date_deactivate
                                        ? Helper.DateNormal(
                                          rowData.date_deactivate
                                        )
                                        : "None"}
                                    </div>
                                  </>
                                ),

                                headerStyle: {
                                  verticalAlign: "inherit",
                                  fontWeight: "bold",
                                  textAlign: "left",
                                },
                                cellStyle: {
                                  textAlign: "left",
                                  fontSize: 12,
                                },
                              },
                              {
                                title: `${t("Status")}`,
                                field: "user_status",
                                render: (rowData) => (
                                  <>
                                    <div className="d-xl-none tc d-md-none d-lg-none">
                                      {t("Status")}
                                    </div>
                                    {
                                      <div
                                        className={
                                          rowData.user_status
                                            ? "badge bg-gradient-success text-xxs"
                                            : "badge badge-sm bg-gradient-secondary"
                                        }
                                      >
                                        {rowData.user_status
                                          ? "Activated"
                                          : "DeActivated"}
                                      </div>
                                    }
                                  </>
                                ),

                                headerStyle: {
                                  verticalAlign: "inherit",
                                  fontWeight: "bold",
                                  textAlign: "left",
                                },
                                cellStyle: {
                                  textAlign: "left",
                                  fontSize: 12,
                                },
                              },
                            ]}
                            data={items}
                            localization={{
                              toolbar: {
                                searchPlaceholder: "Search Party",
                              },
                            }}
                            actions={[
                              (rowData) => ({
                                icon: "edit",
                                tooltip: "Edit",
                                onClick: (event, rowData) => {
                                  handleEdit(rowData.id);
                                },
                              }),

                              (rowData) => ({
                                hidden  : rowData.user_filed !== 'Company' ? false : true  ,
                                icon    : rowData.user_filed !== 'Company' ? rowData.user_status ? "block" : "send" : '',
                                tooltip: rowData.user_filed !== 'Company' ? rowData.user_status
                                  ? "DeActivate"
                                  : "Activate" : '',
                                onClick: (event, rowData) => {
                                  if (rowData.user_filed !== 'Company') {
                                    handleBan(
                                      rowData.id,
                                      rowData.user,
                                      rowData.user_status
                                    );
                                  }
                                },
                              }),
                              rowData => ({
                                icon: (rowData) => (
                                  <span style={{ color: "green" }}>
                                    <i className={"fa fa-solid fa-paper-plane"}></i>
                                  </span>
                                ),
                                tooltip: "Send Activation Link",
                                onClick: (event, rowData) => {
                                  handleActivation(rowData.user);
                                },
                                hidden: rowData.user_status === true,
                              }),
                            ]}
                            options={{
                              headerStyle: {
                                backgroundColor: "white",
                                color: "#245C7F",
                                fontSize: 11,
                              },
                              rowStyle: (rowData, index) => {
                                if (index % 2) {
                                  return { backgroundColor: "#fff" };
                                }
                              },
                              sorting: true,
                              search: false,
                              toolbar: false,
                              paging: true,
                              pageSize: 5, // make initial page size
                              emptyRowsWhenPaging: false, // To avoid of having empty rows
                              pageSizeOptions: [5, 12, 20, 50],
                              paginationType: "stepped",
                              showFirstLastPageButtons: false,
                              actionsColumnIndex: -1,
                            }}
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  <div className="header pb-0 pt-3 mt-4">
                    <div className="d-lg-flex">
                      <div>
                        <h5 className="mb-0 tc">
                          {/* {t("Manage Customer Users")} */}
                          {t("Manage Customer Portal Users")}
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3">
                    <MaterialTable
                      tableRef={customertable}
                      style={{
                        backgroundColor: "var(--bs-table-bg)",
                        borderBottomWidth: "1px",
                        boxShadow:
                          "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                      }}
                      columns={[
                        {
                          title: `${t("Name")}`,
                          field: "first_name",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">
                                {t("Name")}
                              </div>
                              <div>
                                {rowData.user ? rowData.first_name : ""}
                              </div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                        {
                          title: `${t("Email")}`,
                          field: "user.email",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">
                                {t("Email")}
                              </div>
                              <div>
                                {rowData.user ? rowData.user.email : ""}
                              </div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                        {
                          title: `${t("Work Phone")}`,
                          field: "phone_number",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">
                                {t("Work Phone")}
                              </div>
                              <div>
                                {rowData.phone_number
                                  ? rowData.phone_number
                                  : "None"}
                              </div>
                            </>
                          ),
                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },

                        {
                          title: `${t("Status")}`,
                          field: "user.is_active",
                          render: (rowData) => (
                            <>
                              <div className="d-xl-none tc d-md-none d-lg-none">
                                {t("Status")}
                              </div>
                              {
                                <div
                                  className={
                                    rowData.user.is_active == true
                                      ? "badge bg-gradient-success text-xxs"
                                      : "badge badge-sm bg-gradient-secondary"
                                  }
                                >
                                  {rowData.user.is_active == true
                                    ? "Activated"
                                    : "DeActivated"}
                                </div>
                              }
                            </>
                          ),

                          headerStyle: {
                            verticalAlign: "inherit",
                            fontWeight: "bold",
                            textAlign: "left",
                          },
                          cellStyle: {
                            textAlign: "left",
                            fontSize: 12,
                          },
                        },
                      ]}
                      data={customerusers}
                      localization={{
                        toolbar: {
                          searchPlaceholder: "Search Party",
                        },
                      }}
                      actions={[
                        (rowData) => ({
                          icon: "edit",
                          tooltip: "Edit",
                          onClick: (event, rowData) => {
                            handleCustomerEdit(rowData.user.id);
                          },
                        }),

                        (rowData) => ({
                          hidden:
                            customerPermission === "Customer" ? true : false,
                          icon:
                            rowData.user.is_active === true ? "block" : "send",
                          tooltip:
                            rowData.user.is_active === true
                              ? "DeActivate"
                              : "Activate",
                          onClick: (event, rowData) => {
                            handleCustomerActivation(
                              rowData.user.id,
                              rowData.user.is_active
                            );
                          },
                        }),
                      ]}
                      options={{
                        headerStyle: {
                          backgroundColor: "white",
                          color: "#245C7F",
                          fontSize: 11,
                        },
                        rowStyle: (rowData, index) => {
                          if (index % 2) {
                            return { backgroundColor: "#fff" };
                          }
                        },
                        sorting: true,
                        search: false,
                        toolbar: false,
                        paging: true,
                        pageSize: 5, // make initial page size
                        emptyRowsWhenPaging: false, // To avoid of having empty rows
                        pageSizeOptions: [5, 12, 20, 50],
                        paginationType: "stepped",
                        showFirstLastPageButtons: false,
                        actionsColumnIndex: -1,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <ContentLoader
              viewBox="0 0 1000 550"
              backgroundColor="rgba(0,0,0,0.06)"
              foregroundColor="rgba(0,0,0,0.12)"
            >
              <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
              <circle cx="879" cy="123" r="11" />
              <circle cx="914" cy="123" r="11" />
              <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
              <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
              <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
              <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
              <circle cx="880" cy="184" r="11" />
              <circle cx="915" cy="184" r="11" />
              <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
              <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
              <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
              <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
              <circle cx="881" cy="242" r="11" />
              <circle cx="916" cy="242" r="11" />
              <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
              <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
              <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
              <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
              <circle cx="882" cy="303" r="11" />
              <circle cx="917" cy="303" r="11" />
              <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
              <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
              <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
              <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
              <circle cx="881" cy="363" r="11" />
              <circle cx="916" cy="363" r="11" />
              <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
              <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
              <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
              <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
              <circle cx="882" cy="424" r="11" />
              <circle cx="917" cy="424" r="11" />
              <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
              <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
              <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
              <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
              <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
              <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
              <circle cx="882" cy="484" r="11" />
              <circle cx="917" cy="484" r="11" />
              <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
              <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
              <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
              <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
              <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
              <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
              <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
              <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
              <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
              <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
            </ContentLoader>
          )}
        </div>
      </div>

      <div
        className="modal right fade"
        id="edit_contact"
        tabindex="-1"
        role="dialog"
        aria-modal="true"
      ></div>
    </>
  );
}

export default ManageUser;
